import { defineComponent as _defineComponent } from 'vue'
import { computed, nextTick, onUnmounted, ref } from 'vue'
import { useRouter } from 'vue-router/composables'


export default /*#__PURE__*/_defineComponent({
  __name: 'YagifriendsPageLoader',
  setup(__props) {

const YAGIFRIENDS_PATH_PREFIX = '/yagifriends'

const router = useRouter()

/** 直リンクで /yagifriends に入ってきたときの初回ローディング */
const isInitialLoading = ref(
  window.location.pathname.startsWith(YAGIFRIENDS_PATH_PREFIX)
)
/** /yagifriends への出入りの遷移中 */
const isNavigating = ref(false)

const isLoading = computed(() => isInitialLoading.value || isNavigating.value)

const removeBeforeEach = router.beforeEach((to, from, next) => {
  if (
    to.path.startsWith(YAGIFRIENDS_PATH_PREFIX) ||
    from.path.startsWith(YAGIFRIENDS_PATH_PREFIX)
  ) {
    isNavigating.value = true
  }
  next()
})

const removeAfterEach = router.afterEach(() => {
  nextTick(() => {
    isNavigating.value = false
    isInitialLoading.value = false
  })
})

onUnmounted(() => {
  removeBeforeEach()
  removeAfterEach()
})

return { __sfc: true,YAGIFRIENDS_PATH_PREFIX, router, isInitialLoading, isNavigating, isLoading, removeBeforeEach, removeAfterEach }
}

})